import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export const constantRoutes = [{
		path: '/',
		name: '/',
		component: () =>
			import('@/views/index'),
		meta: {
			tabindex: 1,
		},
	},
	{
		path: '/index',
		name: 'index',
		component: () =>
			import('@/views/index'),
		meta: {
			tabindex: 1,
		},
	},
	{
		path: '/fictitious',
		name: 'fictitious',
		component: () =>
			import('@/views/fictitious/list'),
		meta: {
			tabindex: 2,
		},
	},
	{
		path: '/fictitiousinfo',
		name: 'fictitiousinfo',
		component: () =>
			import('@/views/fictitious/info'),
		meta: {
			tabindex: 2,
		},
	},
	{
		path: '/fictitiousdetail',
		name: 'fictitiousdetail',
		component: () =>
			import('@/views/fictitious/detail'),
		meta: {
			tabindex: 2,
			hidehead: 'hidehead',
			hidefoot: 'hidefoot',
			hidenav: 'hidenav',
		},
	},
	{
		path: '/courses',
		name: 'courses',
		component: () =>
			import('@/views/courses/list'),
		meta: {
			tabindex: 3,
		},
	},
	{
		path: '/coursedetail',
		name: 'coursedetail',
		component: () =>
			import('@/views/courses/detail'),
		meta: {
			tabindex: 3,
		},
	},
	{
		path: '/examinelist',
		name: 'examinelist',
		component: () =>
			import('@/views/examine/list'),
		meta: {
			tabindex: 4,
		},
	},
	{
		path: '/examineinfo',
		name: 'examineinfo',
		component: () =>
			import('@/views/examine/info'),
		meta: {
			tabindex: 4,
			hidenav: 'hidenav',
		},
	},
	{
		path: '/examine',
		name: 'examine',
		component: () =>
			import('@/views/examine/index'),
		meta: {
			tabindex: 4,
			hidehead: 'hidehead',
			hidenav: 'hidenav',
		},
	},
	{
		path: '/examdetails',
		name: 'examdetails',
		component: () =>
			import('@/views/examine/detail'),
		meta: {
			tabindex: 4,
			hidehead: 'hidehead',
			hidenav: 'hidenav',
		},
	},
	{
		path: '/vrexamdetail',
		name: 'vrexamdetail',
		component: () =>
			import('@/views/examine/vrdetail'),
		meta: {
			tabindex: 4,
			hidehead: 'hidehead',
			hidefoot: 'hidefoot',
			hidenav: 'hidenav',
		},
	},
	{
		path: '/news',
		name: 'news',
		component: () =>
			import('@/views/news/list'),
		meta: {
			tabindex: 5,
		},
	},
	{
		path: '/newsdetail',
		name: 'newsdetail',
		component: () =>
			import('@/views/news/detail'),
		meta: {
			tabindex: 5,
		},
	},
	{
		path: '/main',
		name: 'main',
		component: () =>
			import('@/views/main'),
		meta: {
			tabindex: 6,
		},
	},
	{
		path: '/teacher',
		name: 'teacher',
		component: () =>
			import('@/views/teacher'),
		meta: {
			tabindex: 7,
		},
	},
	{
		path: '/team',
		name: 'team',
		component: () =>
			import('@/views/team'),
		meta: {
			tabindex: 8,
		},
	},
	{
		path: '/center',
		name: 'center',
		component: () =>
			import('@/views/center/index'),
		meta: {
			tabindex: 0,
		},
	},
	{
		path: '/redirect',
		name: 'redirect',
		component: () =>
			import('@/components/redirect'),
		meta: {
			tabindex: 0,
			hidehead: 'hidehead',
			hidefoot: 'hidefoot',
			hidenav: 'hidenav',
		},
	},
]

const createRouter = () => new Router({
	scrollBehavior: () => ({
		y: 0
	}),
	routes: constantRoutes
})

const router = createRouter()

export function resetRouter() {
	const newRouter = createRouter()
	router.matcher = newRouter.matcher // reset router
}

export default router